import { LayoutTypes } from "@/services/context/layout-helper";
import { useContextStore } from "@/store/context";
import { useProductsStore } from "@/store/products";
import { useProductSearchStore } from "@/store/product-search";
import { useMagasinStore } from "@/store/magasin";
import { useClientStore } from "@/store/client";
import { useGtm } from "@gtm-support/vue-gtm";

export const useTrackingPage = () => {
  const gtm = useGtm();
  const contextStore = useContextStore();
  const productsStore = useProductsStore();
  const productSearchStore = useProductSearchStore();
  const magasinStore = useMagasinStore();
  const clientStore = useClientStore();

  const { layout } = storeToRefs(contextStore);
  const {
    pimCategoryCode: pimCategoryCode,
    productsList: dpProductsList,
    pagination: dpPagination
  } = storeToRefs(productsStore);
  const { productsList: searchProductsList, pagination: searchPagination } =
    storeToRefs(productSearchStore);
  const { id: magasinIdTracking, name: magasinName } =
    storeToRefs(magasinStore);
  const {
    optIn: optIn,
    coursesListNumber: coursesListNumber,
    client: client,
    clientStatut: clientStatut,
    ordersNumber: ordersNumber,
    lastOrderDate: lastOrderDate,
    isPorteurCarteCora: isPorteurCarteCora,
    isPorteurCarteMalin: isPorteurCarteMalin,
    hasCarteCarrefour: hasCarteCarrefour,
    hasAllCardAppairee: hasAllCardAppairee,
    isPro: clientIsPro
  } = storeToRefs(clientStore);

  const { abonnementsActifsByMagasin } = clientStore;

  const trackPage = (
    pageType,
    CatalogueUniverse,
    subCatalogueUniverse,
    catalogueCategory,
    catalogueSubCategory
  ) => {
    const pushObject = {};
    pushObject.environnement = useRuntimeConfig().public.GTM_ENVIRONNEMENT;
    pushObject.pageType = pageType;
    if (CatalogueUniverse) {
      pushObject.universCatalogue = CatalogueUniverse;
    }
    if (subCatalogueUniverse) {
      pushObject.sousUniversCatalogue = subCatalogueUniverse;
    }
    if (catalogueCategory) {
      pushObject.categorieCatalogue = catalogueCategory;
    }
    if (catalogueSubCategory) {
      pushObject.sousCategorieCatalogue = catalogueSubCategory;
    }
    if (magasinIdTracking.value) {
      pushObject.magasinId = magasinIdTracking.value;
    }
    if (magasinName.value) {
      pushObject.magasinNom = magasinName.value;
    }
    let carteFidelite = trackingCodes.LOYALTYCARD.none;
    if (isPorteurCarteCora.value) {
      if (isPorteurCarteMalin.value) {
        carteFidelite = trackingCodes.LOYALTYCARD.twoCards;
      } else {
        carteFidelite = trackingCodes.LOYALTYCARD.cora;
      }
    } else if (isPorteurCarteMalin.value) {
      carteFidelite = trackingCodes.LOYALTYCARD.malin;
    }
    if (hasCarteCarrefour.value) {
      carteFidelite = trackingCodes.LOYALTYCARD.carrefour;
    }
    if (client.value) {
      pushObject.carteFidelite = carteFidelite;
      if (client.value.id) {
        pushObject.userId = client.value.id;
      }
      pushObject.typeCompte = clientIsPro.value
        ? trackingCodes.ACCOUNTTYPE.PRO
        : trackingCodes.ACCOUNTTYPE.STD;
      pushObject.appaire = hasAllCardAppairee.value;
      pushObject.nombreCommande = ordersNumber.value;
      pushObject.statusClient = clientStatut.value;
      pushObject.dateDerniereCommande = lastOrderDate.value;
      pushObject.nombreListeCourse = coursesListNumber.value;
      pushObject.optIn = optIn.value;
      pushObject.abonnementDureeSouscription =
        abonnementsActifsByMagasin(magasinIdTracking.value).length > 0
          ? abonnementsActifsByMagasin(magasinIdTracking.value)[0].attributes
              .actif
            ? abonnementsActifsByMagasin(magasinIdTracking.value)[0].attributes
                .duree + "mois"
            : "échu"
          : "aucun";
    }
    if (
      pageType === trackingCodes.PAGETYPE.category ||
      pageType === trackingCodes.PAGETYPE.univers
    ) {
      if (pimCategoryCode.value) {
        pushObject.categoryCode = pimCategoryCode.value;
      }
      if (pageType === trackingCodes.PAGETYPE.category) {
        pushObject.page_number = dpPagination.value.current_page;
        if (dpProductsList.value.length > 0) {
          pushObject.firstItem = dpProductsList.value[0];
          if (dpProductsList.value.length > 1) {
            pushObject.secondItem = dpProductsList.value[1];
          }
          if (dpProductsList.value.length > 2) {
            pushObject.thirdItem = dpProductsList.value[2];
          }
        }
      }
    } else if (pageType === trackingCodes.PAGETYPE.search) {
      pushObject.page_number = searchPagination.value.current_page;
      if (searchProductsList.value.length > 0) {
        pushObject.firstItem = searchProductsList.value[0];
        if (searchProductsList.value.length > 1) {
          pushObject.secondItem = searchProductsList.value[1];
        }
        if (searchProductsList.value.length > 2) {
          pushObject.thirdItem = searchProductsList.value[2];
        }
      }
    }
    pushObject.event = trackingCodes.EVENTS.ready;
    pushObject.sitetype = layout.value === LayoutTypes.default ? "d" : "m";
    pushObject.version_site = clientIsPro.value ? "pro" : "normal";
    try {
      gtm.trackEvent(pushObject);
    } catch (error) {}
  };

  return { trackPage };
};
